import image1 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image001.jpg";
import image2 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image002.jpg";
import image3 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image003.png";
import image4 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image004.jpg";
import image5 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image005.jpg";
import image6 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image006.jpg";
import image7 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image007.jpg";
import image8 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image008.png";
import image9 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image009.png";
import image10 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image010.jpg";
import image11 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image011.jpg";
import image12 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image012.jpg";
import image13 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image013.jpg";
import image14 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image014.jpg";
import image15 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image015.jpg";
import image16 from "/Users/nikkylu/lumed/src/pages/components/needle.fld/image016.jpg";
import amber from "/Users/nikkylu/lumed/src/pages/components/needle.fld/1045.jpg";

import "./Home.css"

const Needle = () => {
  return (
<div className="Home">
    <div>Syringes & Needles</div>
    <div className="Home-con">
    <div className="Home-sl">
        <div>Syringes</div>
    </div>
    </div>
    <div className="Home-con">
    <img src={image1} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Syringes, sterile, ISO 7886, CE</div>
        <p>2-part: 1ml, 2ml, 5ml, 10ml, 20ml, 50ml</p>
        <p>3-part: 0.5ml, 1ml, 2ml, 3ml, 5ml, 10ml, 20ml, 30ml, 50ml, 60ml, 100ml, 150ml</p>
        <p>luer / luer lock, or catheter tip</p>
        <p>without needle</p>
        <p>with bypacked needle</p>
        <p>with mounted needle</p>
    </div>
</div>

<div className="Home-con">
    <img src={image2} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Insulin Syringes, sterile, ISO 8537, CE</div>
        <p>0.3ml, 0.5ml, 1ml, U-100 or U-40, with integrated needle</p>
        <p>or 1ml, U-100 or U-40, luer connector with mounted or bypacked needle</p>
    </div>
</div>

<div className="Home-con">
    <img src={image3} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Insulin Pen, sterile, CE</div>
        <p>(for the insulin pen needles, pls refer to our below last item for needles)</p>
    </div>
</div>

<div className="Home-con">
    <img src={image4} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Tuberculin Syringes, sterile, CE</div>
        <p>1ml, with mounted needle</p>
    </div>
</div>

<div className="Home-con">
    <img src={image5} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Oral/Enteral Feeding Syringes, sterile, CE</div>
        <p>joint tip as per ISO80369-3,2016</p>
        <p>1ml, 2.5/3ml, 5ml, 10ml, 20ml, 50ml</p>
    </div>
</div>

<div className="Home-con">
    <img src={image6} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Oral Feeding Syringes for Medicines, sterile, BS 3221-7: 1995, CE</div>
        <p>Various sizes</p>
    </div>
</div>

<div className="Home-con">
    <img src={image7} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Syringes with Safety Needles, sterile, ISO 7886, CE</div>
        <p>luer / luer lock</p>
        <p>1ml, 2ml, 5ml, 10ml, 20ml</p>
    </div>
</div>

<div className="Home-con">
    <img src={image8} className="Home-sp"/>
    <div className="Home-s">
        <div>Disposable Safety Syringes, sterile, ISO 7886, CE</div>
        <p>luer lock</p>
        <p>1ml, 2ml, 3ml, 5ml, 10ml, 20ml</p>
    </div>
</div>

<div className="Home-con">
    <img src={image9} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Auto-destructive Syringes, sterile, ISO 7886, CE</div>
        <p>1ml, 3ml, 5ml, 10ml, 20ml</p>
    </div>
</div>

<div className="Home-con">
    <img src={amber} className="Home-sp" alt="Amber syringes" />
    <div className="Home-s">
        <div>Amber Syringes, sterile, ISO 7886, CE</div>
        <p>Amber syringes for light sensitive medications</p>
        <p>luer / luer lock, various sizes</p>
    </div>
</div>
    <div className="Home-con">
    <div className="Home-sl">
        <div>Needles</div>
    </div>
</div>
<div className="Home-con">
    <img src={image10} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Needles, sterile, ISO 7864, CE</div>
        <p>16G, 18G-27G, 28G-30G</p>
    </div>
</div>

<div className="Home-con">
    <img src={image11} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Safety Needles, sterile, ISO 7864, CE</div>
        <p>18G-27G</p>
    </div>
</div>

<div className="Home-con">
    <img src={image12} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Needles with Filter, sterile, ISO 7864, CE</div>
        <p>18G-27G</p>
    </div>
</div>

<div className="Home-con">
    <img src={image13} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Dental Needles, sterile, CE</div>
    </div>
</div>

<div className="Home-con">
    <img src={image14} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Epidural Needles, sterile, CE</div>
    </div>
</div>

<div className="Home-con">
    <img src={image15} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Spinal Needles, sterile, CE</div>
    </div>
</div>

<div className="Home-con">
    <img src={image16} className="Home-sp"/>
    <div className="Home-s">
        <div>Single-Use Insulin Pen Needle, sterile, CE</div>
    </div>
</div>


        </div>
   
  )
}

export default Needle;